import React from 'react';
import { Link } from 'react-router-dom';
import { FolderX, MessageSquare } from 'lucide-react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ChatSession } from '../../../types';

interface ProjectConversationRowProps {
  session: ChatSession;
  onRemove: (sessionId: string) => void;
}

export const ProjectConversationRow: React.FC<ProjectConversationRowProps> = ({
  session,
  onRemove,
}) => {
  const { t, i18n } = useTranslation();
  const lastActivity = new Date(session.lastMessageAt).toLocaleDateString(i18n.language);

  return (
    <li className="flex items-center gap-2 border-b border-gray-100 last:border-b-0 dark:border-slate-700">
      <Link
        to={`/chat/${session.id}`}
        className="flex min-w-0 flex-1 items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-slate-700/50"
      >
        <MessageSquare size={16} className="shrink-0 text-gray-400 dark:text-slate-500" />
        <span className="min-w-0 flex-1 truncate font-medium text-gray-900 dark:text-slate-100">
          {session.title}
        </span>
        <span className="hidden shrink-0 text-xs text-gray-500 dark:text-slate-400 sm:inline">
          {lastActivity}
        </span>
      </Link>
      <Tooltip title={t('projects.conversationMenu.remove')}>
        <IconButton
          size="small"
          aria-label={t('projects.conversationMenu.remove')}
          onClick={() => onRemove(session.id)}
          className="mr-2 text-gray-400 hover:text-red-600 dark:text-slate-500 dark:hover:text-red-400"
        >
          <FolderX size={16} />
        </IconButton>
      </Tooltip>
    </li>
  );
};
